import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Card, Form } from "react-bootstrap";
import { CircularProgress, FormControl } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import UploadFile from "./UploadFile";
import { useLocation, useNavigate } from "react-router-dom";
import Quiz from "./Quiz";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ToastMessage from "components/Dialog/ToastMessage";
import {
  deleteContent,
  getSignedUrl,
  quizBulkUpload,
  vectorizeContent,
} from "ServerAPI/serverAPI";
import axios from "axios";
import _ from "lodash";
import QuestionGenerationContainer from "./quiz-genaration/QuestionGenerationContainer";
import { useToast } from "context/toast-context/ToastProvider";

import {
  courseCategoryOptions,
  courseSubCategoryOptions,
  questionType,
} from "constants/Constants";
import Codesandbox from "./code-sandbox/Codesandbox";
import QuizBulkUpload from "./quiz-genaration/QuizBulkUpload";
import { useCookies } from "react-cookie";
//import generateQuestionsRAG from './quiz-generation/generateQuestionsRAG'; // New local file
import SubjectiveQuiz from "./SubjectiveQuiz";
import { FEATURES, useFeaturePermissions } from "constants/FeaturePermissions";

const AddLecture = ({
  editMode = false,
  setEditMode,
  setShowContentPage,
  allFiles,
  setAllFiles,
  sectionIndex,
  respondSectionId,
  courseId,
  allSections,
  setAllSections,
  allContent,
  setAllContent,
  activeSection,
  setActiveSection,
  activeContent,
  setActiveContent,
  activeQuiz,
  setActiveQuiz,
  setStep,
  resetActiveQuiz,
  editSavedCourse,
  savedCourse,
}) => {
  const [fileInfo, setFileInfo] = useState(null);
  const navigate = useNavigate();
  const [sectionId, setSectionId] = useState(null);
  const [sectionName, setSectionName] = useState("");
  const [fileType, setFileType] = useState("");
  const [isEditMode, setIsEditMode] = useState(editMode);
  const [fileName, setFileName] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [passingPercentage, setPassingPercentage] = useState(null);
  const [finalAssessment, setFinalAssessmentState] = useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const [quizDetails, setQuizDetails] = useState({});
  const [isFileUploadLoading, setIsFileUploadLoading] = useState(false);
  const [subCategoryOfCourse, setSubCategoryOfCourse] = useState(
    courseSubCategoryOptions
  );
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [errors, setErrors] = useState({
    contentTitle: null,
    quiz: null,
  });
  const [quizGenerationResponseData, setQuizGenerationResponseData] = useState(
    []
  );
  const [quizTimer, setQuizTimer] = useState(null);
  const [scheduledAttempt, setScheduledAttempt] = useState(false);
  const [isProctored, setIsProctored] = useState(false);
  const [maxAttempts, setMaxAttempts] = useState(1);
  const [allowMultipleAttempts, setAllowMultipleAttemptsState] = useState(false);

  // When switching the toggle on, seed a sensible default if the stored value
  // is still the single-attempt default; when switching off, the payload
  // builders force maxAttempts back to 1 regardless of what's stored here.
  // Allow Multiple Attempts and Final Assessment are mutually exclusive — a final
  // assessment is meant to be a one-shot evaluation, so turning either one on forces
  // the other off.
  const setAllowMultipleAttempts = (checked) => {
    setAllowMultipleAttemptsState(checked);
    if (checked) {
      setFinalAssessmentState(false);
      if (!maxAttempts || Number(maxAttempts) < 2) {
        setMaxAttempts(3);
      }
    }
  };

  const setFinalAssessment = (checked) => {
    setFinalAssessmentState(checked);
    if (checked) {
      setAllowMultipleAttemptsState(false);
    }
  };
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const { hasFeature } = useFeaturePermissions();
  const [contentDetails, setContentDetails] = useState({
    contentTitle: "",
    contentType: "",
    contentFile: "",
  });

  const [selectedCategory, setSelectedCategory] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isFirstClick, setIsFirstClick] = useState(true);
  const [cookies] = useCookies();
  const { showToast: showToastNotification } = useToast();

  // Calculate effectiveCourseId
  const effectiveCourseId = savedCourse?.courseId || courseId;
  const [fileBlob, setFileBlob] = useState(null);
  // Log props and derived values
  console.log("AddLecture - Props received:", {
    courseId,
    savedCourseCourseId: savedCourse?.courseId,
    effectiveCourseId,
    activeSection,
    sectionId,
    editMode,
    activeQuiz,
    activeContent,
  });

  const resetFile = () => {
    setFileInfo(null);
  };

  const handleFileChange = (e) => {
    resetFile();
    const file = e.target.files[0];
    setFileInfo(file);
    setFileBlob(file); // Cache before S3 upload
  };

  const filterSubCategory = (category) => {
    const filteredSubCategory = courseSubCategoryOptions.filter(
      (subCategory) => subCategory?.categoryName === category
    );
    setSubCategoryOfCourse(filteredSubCategory);
  };

  const handleChange = (e) => {
    setSelectedSubCategory("");
    setSelectedCategory(e.target.value);
    setQuizGenerationResponseData([]);
    const filteredSubCategory = courseSubCategoryOptions.filter(
      (subCategory) => subCategory?.categoryName === e.target.value
    );
    if (e.target.value === "readingMaterial") {
      setSelectedSubCategory("supplementaryMaterial");
    }
    if (e.target.value === "capstoneProject") {
      setSelectedSubCategory("codeSandbox");
    }
    setSubCategoryOfCourse(filteredSubCategory);
    resetFile();
  };

  const handleSubCategoryChange = (e) => {
    const { value } = e.target;
    setSelectedSubCategory(value);
    // Reset quiz generation/upload data when switching between modes
    setQuizGenerationResponseData([]);
  };

  console.log("AddLecture - selectedSubCategory:", selectedSubCategory);

  const handleTitleChange = (e) => {
    setContentDetails((pre) => ({
      ...pre,
      contentTitle: e.target.value,
    }));
  };

  const goBack = () => {
    resetActiveQuiz();
    setEditMode(false);
    if (editMode) setStep(3);
    setShowContentPage(false);
  };

  const addQuizToContent = (quizData = null) => {
    if (checkValidationError()) {
      return;
    }

    // Prevent adding new content in edit mode - should use updateQuizContent instead
    if (editMode && activeQuiz) {
      console.warn("addQuizToContent: Called in edit mode. Use updateQuizContent instead.");
      return;
    }

    let finalQuizData;
    if (quizData) {
      // Use passed data (from SubjectiveQuiz or Generated Quiz)
      finalQuizData = {
        ...quizData,
        contentTitle: contentDetails.contentTitle || quizData.contentTitle,
        sectionId: activeSection?.sectionId,
        contentNumber: activeSection?.content
          ? activeSection.content.length + 1
          : 1,
        sectionNumber: sectionIndex + 1,
        category: selectedCategory || "quiz",
        isProctored: quizData.isProctored ?? isProctored,
      };
    } else {
      // Fallback for old MCQ flow
      finalQuizData = {
        ...quizDetails,
        contentTitle: contentDetails.contentTitle,
        sectionId: activeSection?.sectionId,
        contentNumber: activeSection?.content
          ? activeSection.content.length + 1
          : 1,
        sectionNumber: sectionIndex + 1,
        category: selectedCategory,
        isProctored: isProctored,
      };
    }

    //edex.log("addQuizToContent - Final quiz data:", finalQuizData);

    setAllContent((pre) => [...pre, finalQuizData]);
    setActiveQuiz(finalQuizData);

    // Clear MCQ-specific state if needed
    setQuizDetails({});
    setAllQuestions([]);

    // Reset scheduling state
    setScheduledAttempt(false);
    setStartDate("");
    setStartTime("");
    setEndDate("");
    setEndTime("");

    // Reset proctoring state
    setIsProctored(false);

    // Reset max attempts state
    setMaxAttempts(1);
    setAllowMultipleAttemptsState(false);

    goBack();
  };

  useEffect(() => {
    if (editMode && activeContent) {
      setContentDetails({
        contentTitle: activeContent?.contentTitle || "",
        contentType: activeContent?.contentType || "",
        contentFile: activeContent?.contentFileName || "",
      });
      setFileName(activeContent?.contentFileName || null);
      setSelectedSubCategory(activeContent?.contentType || "");
      filterSubCategory(activeContent?.category || "");
      setSelectedCategory(activeContent?.category || "");

      setPassingPercentage(activeContent?.passingPercentage !== undefined && activeContent?.passingPercentage !== null ? parseFloat(activeContent.passingPercentage) : "");
      // Raw setter, not the mutual-exclusion wrapper — restoring stored data shouldn't
      // trigger the "force the other field off" side effect used for live user interaction.
      setFinalAssessmentState(activeContent?.finalAssessment === true);
      setQuizTimer(activeContent?.quizTimer !== undefined && activeContent?.quizTimer !== null ? Number(activeContent.quizTimer) : "");

      // Initialize scheduling fields
      setScheduledAttempt(activeContent?.scheduledAttempt === true);
      setStartDate(activeContent?.startDate || "");
      setStartTime(activeContent?.startTime || "");
      setEndDate(activeContent?.endDate || "");
      setEndTime(activeContent?.endTime || "");

      // Initialize proctoring field
      setIsProctored(activeContent?.isProctored === true);

      // Initialize max attempts field. Prefer the explicit isMaxAttemptsQuiz flag when the
      // record has it; fall back to inferring from maxAttempts > 1 for records saved before
      // that flag existed, so old data still populates correctly.
      const storedMaxAttempts = activeContent?.maxAttempts !== undefined && activeContent?.maxAttempts !== null ? Number(activeContent.maxAttempts) : 1;
      setMaxAttempts(storedMaxAttempts);
      setAllowMultipleAttemptsState(
        activeContent?.isMaxAttemptsQuiz !== undefined
          ? Boolean(activeContent.isMaxAttemptsQuiz)
          : storedMaxAttempts > 1
      );

      if (activeContent?.contentFileName) {
        setFileInfo({ name: activeContent.contentFileName });
      }

      if (activeContent.contentType === "quizSubjective") {
        // Normalize questions to ensure they have modelAnswer and totalMarks
        const normalizedContent = {
          ...activeContent,
          questions: activeContent.questions?.map(q => ({
            ...q,
            // Ensure modelAnswer exists (check multiple property names)
            modelAnswer: q.modelAnswer || q.model_answer || q.answer || "",
            // Ensure totalMarks exists (check multiple property names, default to 10)
            totalMarks: q.totalMarks || q.marks || q.total_marks || 10
          })) || []
        };
        console.log("AddLecture - Normalized quizSubjective content:", {
          original: activeContent,
          normalized: normalizedContent,
          questionsBefore: activeContent.questions,
          questionsAfter: normalizedContent.questions
        });
        setActiveQuiz(normalizedContent);
      } else if (activeContent.contentType === "quiz") {
        setActiveQuiz(activeContent);
        if (activeContent.questions) {
          setAllQuestions(activeContent.questions);
        }
      }

      setSectionId(activeContent?.sectionId || null);
    } else {
      setSectionId(activeSection?.sectionId || null);
    }
  }, [editMode, activeContent, activeSection]);

  const checkValidationError = () => {
    if (!contentDetails.contentTitle) {
      setErrors((pre) => ({
        ...pre,
        contentTitle: "Please fill the content title",
      }));
      return true;
    } else {
      setErrors((pre) => ({ ...pre, contentTitle: null }));
    }

    if (selectedSubCategory === "quiz" && !effectiveCourseId) {
      setErrors((pre) => ({
        ...pre,
        quiz: "Course ID is missing. Please ensure a valid course is selected.",
      }));
      return true;
    } else if (selectedSubCategory === "quiz" && !activeSection?.sectionId) {
      setErrors((pre) => ({
        ...pre,
        quiz: "Section ID is missing. Please ensure a valid section is selected.",
      }));
      return true;
    } else {
      setErrors((pre) => ({ ...pre, quiz: null }));
    }

    // Validate scheduled duration against quiz timer
    if ((selectedSubCategory === "quiz" || selectedSubCategory === "quizSubjective" || selectedCategory === "quiz") && scheduledAttempt) {
      if (startDate && startTime && endDate && endTime && quizTimer) {
        const startStr = `${startDate} ${startTime}`;
        const endStr = `${endDate} ${endTime}`;
        const startTimeObj = dayjs(startStr);
        const endTimeObj = dayjs(endStr);
        
        const durationInMinutes = endTimeObj.diff(startTimeObj, "minute");
        
        // Validate that end time is after start time
        if (durationInMinutes <= 0) {
            const msg = "Scheduled End Date/Time must be after Start Date/Time.";
            setErrors((pre) => ({
                ...pre,
                quiz: msg,
            }));
            showToastNotification(msg, "error");
            return true;
        }
        
        if (durationInMinutes < Number(quizTimer)) {
          const msg = `Scheduled window duration (${durationInMinutes} mins) is less than the Quiz Timer (${quizTimer} mins). Please increase the schedule window or reduce the quiz timer.`;
          setErrors((pre) => ({
            ...pre,
            quiz: msg,
          }));
          showToastNotification(msg, "error");
          return true;
        }
      } else {
          // If scheduled is checked, all these fields must be provided
          const missing = [];
          if (!startDate) missing.push("Start Date");
          if (!startTime) missing.push("Start Time");
          if (!endDate) missing.push("End Date");
          if (!endTime) missing.push("End Time");
          if (!quizTimer) missing.push("Quiz Timer");
          const msg = `Please fill in all scheduling fields. Missing: ${missing.join(", ")}`;
          setErrors((pre) => ({
            ...pre,
            quiz: msg,
          }));
          showToastNotification(msg, "error");
          return true;
      }
    }

    return false;
  };

  const shouldVectorize = () => {
    return (
      selectedSubCategory === "video" ||
      selectedSubCategory === "supplementaryMaterial" ||
      selectedCategory === "readingMaterial"
    );
  };

  const updateContent = () => {
    if (checkValidationError()) {
      return;
    }
    const newContent = {
      ...contentDetails,
      sectionId: activeContent.sectionId,
      contentId: activeContent?.contentId || "",
      contentType: selectedSubCategory,
      category: selectedCategory,
      contentNumber: activeContent.contentNumber,
      contentFileName: fileInfo?.name || fileName,
      sectionNumber: activeContent.sectionNumber,
      vectorSpace: shouldVectorize(),
    };
    const existingSections = [...allSections];
    existingSections.forEach((section, index) => {
      if (section.sectionId === activeSection.sectionId) {
        const contentNumberToMatch = activeContent?.contentNumber;
        const contentIdToMatch = activeContent?.contentId;
        const tempIdToMatch = activeContent?.tempId;

        // 1. Update merged content
        section.content = (section.content || []).map((content, ind) => {
          const isMatch = (contentNumberToMatch && String(content.contentNumber) === String(contentNumberToMatch)) ||
            (contentIdToMatch && content.contentId === contentIdToMatch) ||
            (tempIdToMatch && content.tempId === tempIdToMatch);

          if (isMatch) {
            return {
              ...newContent,
              contentNumber: content.contentNumber || newContent.contentNumber || (ind + 1),
              contentId: content.contentId || newContent.contentId,
              tempId: content.tempId || newContent.tempId
            };
          }
          return content;
        });
        // 2. Update legacy courseContent
        if (section.courseContent) {
          section.courseContent = section.courseContent.map((content) => {
            const isMatch = (contentNumberToMatch && String(content.contentNumber) === String(contentNumberToMatch)) ||
              (contentIdToMatch && content.contentId === contentIdToMatch) ||
              (tempIdToMatch && content.tempId === tempIdToMatch);
            if (isMatch) return { ...newContent, contentNumber: content.contentNumber || newContent.contentNumber };
            return content;
          });
        }
        // 3. Update subjectiveQuizzes
        if (section.subjectiveQuizzes) {
          section.subjectiveQuizzes = section.subjectiveQuizzes.map((quiz) => {
            const isMatch = (contentNumberToMatch && String(quiz.contentNumber) === String(contentNumberToMatch)) ||
              (contentIdToMatch && quiz.contentId === contentIdToMatch) ||
              (tempIdToMatch && quiz.tempId === tempIdToMatch);
            if (isMatch) return { ...newContent, contentNumber: quiz.contentNumber || newContent.contentNumber };
            return quiz;
          });
        }

        section.content = _.uniqBy(section.content || [], "contentNumber");
        if (section.courseContent) section.courseContent = _.uniqBy(section.courseContent, "contentNumber");
        if (section.subjectiveQuizzes) section.subjectiveQuizzes = _.uniqBy(section.subjectiveQuizzes, "contentNumber");
      }
    });

    if (editMode && typeof editSavedCourse === 'function') {
      const updatedCourseData = {
        ...savedCourse,
        sections: existingSections,
      };
      editSavedCourse(updatedCourseData);
      console.log("AddLecture - Course updated via editSavedCourse:", updatedCourseData);
    }

    setEditMode(false);
    setAllSections([...existingSections]);
    setStep(3);
    setShowContentPage(false);
  };

  const updateQuizContent = (updatedQuizData = null) => {
    if (checkValidationError()) return;

    // Pull the live state out of allSections because updateQuizQuestion modifies allSections directly
    // and bypasses activeQuiz, meaning activeQuiz is totally stale on user edits.
    const liveSection = allSections.find(s => s.sectionId === activeSection.sectionId);
    const liveQuiz = liveSection?.content?.find(c => String(c.contentNumber) === String(activeQuiz?.contentNumber));

    const quizToSave = updatedQuizData || liveQuiz || activeQuiz;

    // Strictly enforce parent state to ensure user edits are tracked
    const timerValue = quizTimer ? Number(quizTimer) : 0;

    // Sanitize any legacy empty options out of the question arrays before pushing to DB
    const sanitizedQuestions = quizToSave?.questions?.map(q => ({
      ...q,
      answers: q.answers ? q.answers.filter(opt => opt && String(opt.answer).trim() !== "") : []
    })) || [];

    console.log("AddLecture - updateQuizContent - Timer values:", {
      quizToSaveTimer: quizToSave?.quizTimer,
      parentStateTimer: quizTimer,
      finalTimerValue: timerValue
    });

    const newContent = {
      ...contentDetails,
      ...quizToSave,
      questions: sanitizedQuestions,
      contentTitle: contentDetails.contentTitle,
      contentType: selectedSubCategory, // "quiz" or "quizSubjective"
      category: selectedCategory,
      contentNumber: quizToSave.contentNumber,
      sectionNumber: quizToSave.sectionNumber,
      passingPercentage: parseFloat(passingPercentage),
      quizTimer: timerValue,
      finalAssessment: finalAssessment,
      scheduledAttempt: scheduledAttempt,
      ...(scheduledAttempt && {
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
      }),
      isProctored: isProctored,
      isMaxAttemptsQuiz: !(scheduledAttempt || isProctored) && allowMultipleAttempts,
      maxAttempts: (scheduledAttempt || isProctored || !allowMultipleAttempts) ? 1 : Math.max(2, Number(maxAttempts) || 2),
      sectionId: activeSection.sectionId,
    };
    const existingSections = [...allSections];
    existingSections.forEach((section, index) => {
      if (section.sectionId === activeSection.sectionId) {
        const contentNumberToMatch = activeQuiz?.contentNumber || quizToSave?.contentNumber;
        const contentIdToMatch = activeQuiz?.contentId || quizToSave?.contentId;
        const tempIdToMatch = activeQuiz?.tempId || quizToSave?.tempId;

        let matchFound = false;

        // 1. Update the merged 'content' array (used for UI)
        section.content = (section.content || []).map((content, ind) => {
          const isMatch = (contentNumberToMatch && String(content.contentNumber) === String(contentNumberToMatch)) ||
            (contentIdToMatch && content.contentId === contentIdToMatch) ||
            (tempIdToMatch && content.tempId === tempIdToMatch);

          if (isMatch) {
            matchFound = true;
            // Ensure newContent keeps the found item's identifiers
            const updatedContent = {
              ...newContent,
              contentNumber: content.contentNumber || newContent.contentNumber || (ind + 1),
              contentId: content.contentId || newContent.contentId,
              tempId: content.tempId || newContent.tempId
            };
            return updatedContent;
          }
          return content;
        });

        // 2. Update 'courseContent' array (legacy structure)
        if (section.courseContent) {
          section.courseContent = section.courseContent.map((content) => {
            const isMatch = (contentNumberToMatch && String(content.contentNumber) === String(contentNumberToMatch)) ||
              (contentIdToMatch && content.contentId === contentIdToMatch) ||
              (tempIdToMatch && content.tempId === tempIdToMatch);
            if (isMatch) return { ...newContent, contentNumber: content.contentNumber || newContent.contentNumber };
            return content;
          });
        }

        // 3. Update 'subjectiveQuizzes' array (new structure)
        if (section.subjectiveQuizzes) {
          section.subjectiveQuizzes = section.subjectiveQuizzes.map((quiz) => {
            const isMatch = (contentNumberToMatch && String(quiz.contentNumber) === String(contentNumberToMatch)) ||
              (contentIdToMatch && quiz.contentId === contentIdToMatch) ||
              (tempIdToMatch && quiz.tempId === tempIdToMatch);
            if (isMatch) return { ...newContent, contentNumber: quiz.contentNumber || newContent.contentNumber };
            return quiz;
          });
        }

        // If no match was found, log error but don't add duplicate
        if (!matchFound) {
          console.error("updateQuizContent: No matching content found by any identifier:", {
            contentNumberToMatch,
            contentIdToMatch,
            tempIdToMatch
          });
        }

        section.content = _.uniqBy(section.content || [], "contentNumber");
        if (section.courseContent) section.courseContent = _.uniqBy(section.courseContent, "contentNumber");
        if (section.subjectiveQuizzes) section.subjectiveQuizzes = _.uniqBy(section.subjectiveQuizzes, "contentNumber");
      }
    });

    // NOTE: Do NOT call setAllContent here. Doing so triggers Curriculum.js's
    // putContentsInRespectiveSection useEffect, which reads a stale snapshot of
    // allSections and overwrites our update, reverting quiz config changes.
    // allSections is already directly updated via setAllSections below.

    if (editMode && typeof editSavedCourse === 'function') {
      const updatedCourseData = {
        ...savedCourse,
        sections: existingSections,
      };
      editSavedCourse(updatedCourseData);
      console.log("AddLecture - Course updated via editSavedCourse:", updatedCourseData);
    }

    setEditMode(false);
    console.log("updateQuizContent - FINAL quiz config being committed:", {
      passingPercentage: newContent.passingPercentage,
      quizTimer: newContent.quizTimer,
      finalAssessment: newContent.finalAssessment,
      contentNumber: newContent.contentNumber,
      selectedSubCategory,
    });
    setAllSections([...existingSections]);
    setStep(3);
    setShowContentPage(false);
    setActiveQuiz(null);
  };

  const handleQuizSubmit = (quiz) => {
    if (checkValidationError()) return;
    console.log("AddLecture - handleQuizSubmit:", quiz);
    let questions = [];
    if (editMode) {
      const allQuestions = [...(activeQuiz?.questions || []), quiz];
      setAllQuestions([...allQuestions]);
      questions = [...allQuestions];

      const updatedQuizDetails = {
        ...activeQuiz,
        questions,
      };
      setQuizDetails(updatedQuizDetails);

      // Sync with allSections so updateQuizContent doesn't read a stale snapshot
      let sections = [...allSections];
      const targetSection = sections.find(
        (section) => section.sectionId === activeSection.sectionId
      );

      if (targetSection) {
        const contentNumberToMatch = activeQuiz?.contentNumber;
        const contentIdToMatch = activeQuiz?.contentId;
        const tempIdToMatch = activeQuiz?.tempId;

        const quizItem = targetSection.content.find((content) => {
          if (contentNumberToMatch !== undefined && content.contentNumber === contentNumberToMatch) return true;
          if (contentIdToMatch && content.contentId === contentIdToMatch) return true;
          if (tempIdToMatch && content.tempId === tempIdToMatch) return true;
          return false;
        });

        if (quizItem) {
          quizItem.questions = questions;
          setAllSections([...sections]);

          if (typeof editSavedCourse === "function") {
            const updatedCourseData = {
              ...savedCourse,
              sections,
            };
            editSavedCourse(updatedCourseData);
            console.log("AddLecture - Course updated via editSavedCourse after adding question:", updatedCourseData);
          }
        }
      }
    } else {
      questions = [...allQuestions, quiz];
      setAllQuestions(questions);
      const quizDetailsBase = {
        contentNumber: activeSection?.content
          ? activeSection?.content.length + 1
          : 1,
        contentTitle: contentDetails.contentTitle,
        contentType: selectedSubCategory,
        category: selectedCategory,
        sectionNumber: sectionIndex + 1,
        sectionId: activeSection?.sectionId,
        contentFileName: fileInfo?.name,
        questions,
        passingPercentage: parseFloat(passingPercentage),
        finalAssessment,
        quizTimer,
        scheduledAttempt,
        isProctored,
      };

      // Only include scheduling fields if scheduledAttempt is true
      if (scheduledAttempt) {
        quizDetailsBase.startDate = startDate;
        quizDetailsBase.startTime = startTime;
        quizDetailsBase.endDate = endDate;
        quizDetailsBase.endTime = endTime;
      }

      setQuizDetails(quizDetailsBase);
    }
  };

  const handleGeneratedQuizSubmit = async (
    quizContent,
    passingPercentage,
    finalAssessment,
    quizTimer
  ) => {
    console.log("AddLecture - handleGeneratedQuizSubmit:", {
      quizContent,
      passingPercentage,
      finalAssessment,
      quizTimer
    });

    if (checkValidationError()) {
        return;
    }

    if (!effectiveCourseId) {
      console.error("AddLecture - handleGeneratedQuizSubmit - Course ID is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Course ID is missing. Please ensure a valid course is selected.",
      }));
      return;
    }

    if (!activeSection?.sectionId) {
      console.error("AddLecture - handleGeneratedQuizSubmit - Section ID is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Section ID is missing. Please ensure a valid section is selected.",
      }));
      return;
    }

    // Transform questions to match normal quiz structure
    const allQuestions = Object.values(quizContent).flat();
    const questions = allQuestions
      .filter(q => q && q.question) // Remove empty questions
      .map((quiz, index) => {
        // Use sequential IDs starting from 1
        return {
          ...quiz,
          id: index + 1, // Use sequential numbers: 1, 2, 3, 4, 5, 6
          question: quiz.question,
          explanation: quiz.explanation || "",
          answers: (quiz.answers || []).filter(opt => opt && String(opt.answer).trim() !== ""),
          correctAnswer: quiz.correctAnswer || 0,
          answerSelectionType: quiz.answerSelectionType || "single",
          interface: quiz.interface || "radio",
          point: quiz.marks ? Number(quiz.marks) : 1
        };
      });

    console.log("AddLecture - Transformed questions with fixed IDs:", questions);

    const newContent = {
      contentNumber: activeSection?.content ? activeSection?.content.length + 1 : 1,
      contentTitle: contentDetails.contentTitle,
      contentType: "quiz",
      category: selectedCategory,
      sectionNumber: sectionIndex + 1,
      sectionId: activeSection?.sectionId,
      contentFileName: fileInfo?.name,
      questions: questions,
      passingPercentage: parseFloat(passingPercentage) || 70,
      finalAssessment: Boolean(finalAssessment),
      quizTimer: Number(quizTimer), // Keep as minutes - NO conversion
      scheduledAttempt: scheduledAttempt,
      ...(scheduledAttempt && {
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
      }),
      isProctored: Boolean(isProctored),
      isMaxAttemptsQuiz: !(scheduledAttempt || isProctored) && allowMultipleAttempts,
      maxAttempts: (scheduledAttempt || isProctored || !allowMultipleAttempts) ? 1 : Math.max(2, Number(maxAttempts) || 2),
    };

    console.log("AddLecture - Final quiz content:", newContent);

    setAllContent((pre) => [...pre, newContent]);

    if (editMode && typeof editSavedCourse === 'function') {
      const existingSections = [...allSections];
      existingSections.forEach((section, index) => {
        if (section.sectionId === activeSection.sectionId) {
          section.content = section.content.map((content, ind) =>
            content.contentNumber === activeContent?.contentNumber
              ? newContent
              : content
          );
        }
      });
      const updatedCourseData = {
        ...savedCourse,
        sections: existingSections,
      };
      editSavedCourse(updatedCourseData);
    }

    goBack();
  };

  const updateProblemStatementToContents = (details) => {
    if (checkValidationError()) {
      return;
    }

    const newContent = {
      contentTitle: contentDetails.contentTitle,
      contentType: selectedSubCategory,
      category: selectedCategory,
      sectionNumber: sectionIndex + 1,
      sectionId: activeSection?.sectionId,
      contentNumber: activeContent.contentNumber,
      contentId: activeContent?.contentId || "",
      problemStatement: details?.problemStatement || "",
      language: details?.language || "",
      version: details?.version || "",
      fileRequired: details?.fileRequired || false,
      fileName: details?.fileName || "",
      fileUrl: details?.fileUrl || "",
      testCases: details?.testCases || [],
      solution: details?.solution || "",
      isProctored: Boolean(details?.isProctored),
      timerMinutes: details?.timerMinutes ? Number(details.timerMinutes) : null,
      marksPerTestCase: details?.marksPerTestCase ? Number(details.marksPerTestCase) : 1,
      createdDate: new Date(),
    };

    const existingSections = [...allSections];
    existingSections.forEach((section, index) => {
      if (section.sectionId === activeSection.sectionId) {
        section.content = section.content.map((content, ind) =>
          content.contentNumber === activeContent.contentNumber ? newContent : content
        );
      }
    });

    if (editMode && typeof editSavedCourse === 'function') {
      const updatedCourseData = {
        ...savedCourse,
        sections: existingSections,
      };
      editSavedCourse(updatedCourseData);
      console.log("AddLecture - Course updated via editSavedCourse:", updatedCourseData);
    }

    setEditMode(false);
    setAllSections([...existingSections]);
    setStep(3);
    setShowContentPage(false);
  };

  const addProblemStatementToContents = (details) => {
    if (checkValidationError()) {
      return;
    }

    const contentNumber = activeSection?.content
      ? activeSection.content.length + 1
      : 1;

    const newContent = {
      contentTitle: contentDetails.contentTitle,
      contentType: selectedSubCategory,
      category: selectedCategory,
      sectionNumber: sectionIndex + 1,
      sectionId: activeSection?.sectionId,
      contentNumber,
      problemStatement: details?.problemStatement || "",
      language: details?.language || "",
      version: details?.version || "",
      fileRequired: details?.fileRequired || false,
      fileName: details?.fileName || "",
      fileUrl: details?.fileUrl || "",
      testCases: details?.testCases || [],
      solution: details?.solution || "",
      isProctored: Boolean(details?.isProctored),
      timerMinutes: details?.timerMinutes ? Number(details.timerMinutes) : null,
      marksPerTestCase: details?.marksPerTestCase ? Number(details.marksPerTestCase) : 1,
      createdDate: new Date(),
    };

    const existingSections = [...allSections];
    existingSections.forEach((section) => {
      if (section.sectionId === activeSection.sectionId) {
        section.content = [...(section.content || []), newContent];
      }
    });

    setAllSections(existingSections);
    setAllContent((pre) => [...pre, newContent]);

    if (editMode && typeof editSavedCourse === 'function') {
      const updatedCourseData = {
        ...savedCourse,
        sections: existingSections,
      };
      editSavedCourse(updatedCourseData);
    }

    goBack();
  };

  const handleQuizBulkUpload = async (payload) => {
    console.log("AddLecture - handleQuizBulkUpload:", payload);
    const response = await quizBulkUpload(payload);
    if (response.status === 200) {
      setQuizGenerationResponseData(response?.data?.data);
      return response;
    }
    return response;
  };

  const updateQuizQuestion = (updatedQuestion) => {
    console.log("AddLecture - updateQuizQuestion:", updatedQuestion);
    let sections = [...allSections];
    const targetSection = sections.find(
      (section) => section.sectionId === activeSection.sectionId
    );

    if (!targetSection) return;

    // 1. Find the quiz in the section's content array using robust matching
    const contentNumberToMatch = activeQuiz?.contentNumber;
    const contentIdToMatch = activeQuiz?.contentId;
    const tempIdToMatch = activeQuiz?.tempId;

    const quizItem = targetSection.content.find((content) => {
      if (contentNumberToMatch !== undefined && content.contentNumber === contentNumberToMatch) return true;
      if (contentIdToMatch && content.contentId === contentIdToMatch) return true;
      if (tempIdToMatch && content.tempId === tempIdToMatch) return true;
      return false;
    });

    if (quizItem && quizItem.questions) {
      // 2. Update the specific question in the found quiz
      quizItem.questions = quizItem.questions.map((q) =>
        q.id === updatedQuestion.id ? { ...updatedQuestion } : q
      );

      // 3. Update the local states to reflect the change immediately
      setAllQuestions([...quizItem.questions]);
      setActiveQuiz((prev) => ({
        ...prev,
        questions: [...quizItem.questions],
      }));
    }

    // 4. Update the section state
    setAllSections([...sections]);

    if (editMode && typeof editSavedCourse === "function") {
      const updatedCourseData = {
        ...savedCourse,
        sections,
      };
      editSavedCourse(updatedCourseData);
      console.log("AddLecture - Course updated via editSavedCourse:", updatedCourseData);
    }
  };
  const submitQuizGenerationForm = async (
    questionData,
    totalQuestions,
    quizTimer
  ) => {
    try {
      setIsGenerating(true);
      console.log("AddLecture - submitQuizGenerationForm:", {
        effectiveCourseId,
        sectionId: activeSection?.sectionId,
        questionData,
        totalQuestions,
        quizTimer,
      });

      if (!effectiveCourseId) {
        console.error("AddLecture - submitQuizGenerationForm - Course ID is missing", { courseId, savedCourse });
        setErrors((pre) => ({
          ...pre,
          quiz: "Course ID is missing. Please ensure a valid course is selected.",
        }));
        setIsGenerating(false);
        return;
      }
      if (!activeSection?.sectionId) {
        console.error("AddLecture - submitQuizGenerationForm - Section ID is missing");
        setErrors((pre) => ({
          ...pre,
          quiz: "Section ID is missing. Please ensure a valid section is selected.",
        }));
        setIsGenerating(false);
        return;
      }

      const vectorizeContentPayload = {
        courseId: effectiveCourseId,
        sectionId: activeSection?.sectionId,
        finalAssessment: questionData.finalAssessment,
      };

      const quizGenerationPayload = {
        numOfQuestions: totalQuestions,
        questionType: ["mcq", "fill_blanks", "true_false"],
        difficultyLevel: ["medium", "hard", "easy"],
        finalAssessment: questionData.finalAssessment,
        quizTimer,
      };

      if (isFirstClick) {
        await deleteContent();
        const response = await vectorizeContent(vectorizeContentPayload);
        console.log("AddLecture - vectorizeContent response:", response.data);
        response.status === 200 && setIsFirstClick(false);
      }

      // const response = await generateQuestions(quizGenerationPayload);
      // console.log("AddLecture - generateQuestions response:", response.data);
      const formattedResponse = response?.data?.questions?.map((question) => {
        if (question?.type === "true_false") {
          const answers = question?.answers?.map((answer) => {
            if (answer === "True") {
              return { answer: "True", value: 1 };
            } else if (answer === "False") {
              return { answer: "False", value: 2 };
            }
            return answer;
          });
          let correctAnswer = question.correctAnswer === true ? 1 : 2;
          return { ...question, answers, correctAnswer };
        }
        return question;
      });
      setQuizGenerationResponseData(formattedResponse);
      setIsGenerating(false);
    } catch (e) {
      console.error("AddLecture - submitQuizGenerationForm error:", e, {
        message: e.message,
        response: e.response?.data,
      });
      setErrors((pre) => ({
        ...pre,
        quiz: "Issue in generation of questions, please regenerate",
      }));
      setIsGenerating(false);
    }
  };

  const removeQuiz = (payload) => {
    console.log("AddLecture - removeQuiz called with payload:", payload);
    // Placeholder for removeQuiz implementation
  };

  const handleUploadFile = async () => {
    if (checkValidationError()) {
      console.error("AddLecture - handleUploadFile - Validation error: Content title is missing");
      return;
    }
    console.log("AddLecture - handleUploadFile - Inputs:", {
      effectiveCourseId,
      courseId,
      savedCourseCourseId: savedCourse?.courseId,
      sectionId: activeSection?.sectionId,
      fileName: fileInfo?.name,
      userId: cookies?.userId,
      editMode,
    });

    if (!savedCourse) {
      console.error("AddLecture - handleUploadFile - savedCourse is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Course data is missing. Please ensure a valid course is selected.",
      }));
      return;
    }
    if (!effectiveCourseId) {
      console.error("AddLecture - handleUploadFile - Course ID is missing", { courseId, savedCourse });
      setErrors((pre) => ({
        ...pre,
        quiz: "Course ID is missing. Please ensure a valid course is selected.",
      }));
      return;
    }
    if (!activeSection?.sectionId) {
      console.error("AddLecture - handleUploadFile - Section ID is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Section ID is missing. Please ensure a valid section is selected.",
      }));
      return;
    }
    if (!fileInfo) {
      console.error("AddLecture - handleUploadFile - No file selected");
      setErrors((pre) => ({
        ...pre,
        quiz: "No file selected. Please select a file to upload.",
      }));
      return;
    }

    setIsFileUploadLoading(true);
    const payload = {
      courseId: effectiveCourseId,
      sectionId: activeSection?.sectionId,
      fileName: fileInfo?.name,
      method: "PUT",
      userId: cookies?.userId,
    };
    console.log("AddLecture - handleUploadFile - Payload for getSignedUrl:", payload);

    try {
      const response = await getSignedUrl(payload);
      console.log("AddLecture - handleUploadFile - getSignedUrl response:", {
        objectUrl: response.data.objectUrl,
        preSignedUrl: response.data.preSignedUrl,
        fullResponse: response.data,
      });

      const fileResponse = await axios.put(response.data.preSignedUrl, fileInfo, {
        headers: {
          "Content-Type": fileInfo?.type,
        },
      });
      console.log("AddLecture - handleUploadFile - File upload response:", fileResponse.status);

      if (fileResponse.status === 200) {
        let contentNumber = activeSection?.content
          ? activeSection?.content.length + 1
          : 1;

        const content = {
          contentTitle: contentDetails.contentTitle,
          contentType: selectedSubCategory,
          category: selectedCategory,
          sectionNumber: sectionIndex + 1,
          sectionId: activeSection?.sectionId,
          contentFileName: fileInfo?.name,
          contentNumber,
          vectorSpace: shouldVectorize(),
        };

        setAllContent((pre) => _.compact([...pre, content]));
        console.log("AddLecture - handleUploadFile - Content added:", content);

        if (editMode && typeof editSavedCourse === 'function') {
          const existingSections = [...allSections];
          existingSections.forEach((section) => {
            if (section.sectionId === activeSection.sectionId) {
              section.content = [...(section.content || []), content];
            }
          });
          const updatedCourseData = {
            ...savedCourse,
            sections: existingSections,
          };
          editSavedCourse(updatedCourseData);
        }

        // ————————————————————————
        // VECTORIZATION
        // ————————————————————————
        if (
          selectedSubCategory === "video" ||
          selectedSubCategory === "supplementaryMaterial" ||
          selectedCategory === "readingMaterial"
        ) {
          if (!fileBlob) {
            console.warn("File blob not cached — skipping vectorization");
          } else {
            const s3FileName = decodeURIComponent(
              response.data.objectUrl?.split('/').pop() || fileBlob.name
            );

            const vectorFile = new File([fileBlob], s3FileName, {
              type: fileBlob.type,
            });

            const { vectorGenerator } = await import("ServerAPI/serverAPI");

            vectorGenerator(
              vectorFile,                    // file
              cookies.organizationId,                // organization_id
              activeSection.sectionId        // section_id
            ).catch((err) => {
              console.error("Vectorization failed:", err);
            });
          }
        }
        // ————————————————————————

      }
    } catch (error) {
      console.error("AddLecture - handleUploadFile - Error:", error, {
        message: error.message,
        response: error.response?.data,
      });
      setErrors((pre) => ({
        ...pre,
        quiz: "Failed to upload file. Please try again.",
      }));
    }

    setIsFileUploadLoading(false);
    goBack();
  };

  const handleUpdateFile = async () => {
    if (checkValidationError()) {
      console.error("AddLecture - handleUpdateFile - Validation error: Content title is missing");
      return;
    }
    console.log("AddLecture - handleUpdateFile - Inputs:", {
      effectiveCourseId,
      courseId,
      savedCourseCourseId: savedCourse?.courseId,
      sectionId: activeSection?.sectionId,
      fileName: fileInfo?.name,
      existingFileName: fileName,
      userId: cookies?.userId,
      editMode,
    });

    if (!savedCourse) {
      console.error("AddLecture - handleUpdateFile - savedCourse is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Course data is missing. Please ensure a valid course is selected.",
      }));
      return;
    }
    if (!effectiveCourseId) {
      console.error("AddLecture - handleUpdateFile - Course ID is missing", { courseId, savedCourse });
      setErrors((pre) => ({
        ...pre,
        quiz: "Course ID is missing. Please ensure a valid course is selected.",
      }));
      return;
    }
    if (!activeSection?.sectionId) {
      console.error("AddLecture - handleUpdateFile - Section ID is missing");
      setErrors((pre) => ({
        ...pre,
        quiz: "Section ID is missing. Please ensure a valid section is selected.",
      }));
      return;
    }

    setIsFileUploadLoading(true);
    if (fileInfo) {
      const payload = {
        courseId: effectiveCourseId,
        sectionId: activeSection?.sectionId,
        existingFileName: fileName,
        fileName: fileInfo?.name,
        method: "MODIFY",
        userId: cookies?.userId,
      };
      console.log("AddLecture - handleUpdateFile - Payload for getSignedUrl:", payload);

      try {
        const response = await getSignedUrl(payload);
        console.log("AddLecture - handleUpdateFile - getSignedUrl response:", {
          objectUrl: response.data.objectUrl,
          preSignedUrl: response.data.preSignedUrl,
          fullResponse: response.data,
        });

        const fileResponse = await axios.put(
          response.data.preSignedUrl,
          fileInfo,
          {
            headers: {
              "Content-Type": fileInfo?.type,
            },
          }
        );
        console.log("AddLecture - handleUpdateFile - File update response:", fileResponse.status);

        if (fileResponse.status === 200) {
          if (
            selectedSubCategory === "video" ||
            selectedSubCategory === "supplementaryMaterial" ||
            selectedCategory === "readingMaterial"
          ) {
            if (!fileBlob) {
              console.warn("File blob not cached — skipping vectorization");
            } else {
              const s3FileName = decodeURIComponent(
                response.data.objectUrl?.split('/').pop() || fileBlob.name
              );

              const vectorFile = new File([fileBlob], s3FileName, {
                type: fileBlob.type,
              });

              const { vectorGenerator } = await import("ServerAPI/serverAPI");

              vectorGenerator(
                vectorFile,                    // file
                cookies.organizationId,        // organization_id
                activeSection.sectionId        // section_id
              ).catch((err) => {
                console.error("Vectorization failed:", err);
              });
            }
          }
        }
      } catch (error) {
        console.error("AddLecture - handleUpdateFile - Error:", error, {
          message: error.message,
          response: error.response?.data,
        });
        setErrors((pre) => ({
          ...pre,
          quiz: "Failed to update file. Please try again.",
        }));
      }
    }
    updateContent();
    setIsFileUploadLoading(false);
  };

  const handleToastClose = () => {
    setShowToast(false);
    navigate("/add-new-course", {
      replace: true,
      state: { fromAddLecturePage: true, editMode: true },
    });
  };

  useEffect(() => {
    if (allQuestions.length > 0) {
      console.log("AddLecture - allQuestions changed, updating activeQuiz. Current questions count:", allQuestions.length);
      setActiveQuiz((prev) => {
        if (!prev) {
          console.warn("AddLecture - setActiveQuiz: previous activeQuiz was null, cannot spread.");
          return prev;
        }
        console.log("AddLecture - setActiveQuiz - preserved properties:", Object.keys(prev).filter(k => k !== 'questions'));
        return {
          ...prev,
          contentNumber: prev.contentNumber, // Explicitly ensure these are kept
          contentId: prev.contentId,
          tempId: prev.tempId,
          questions: allQuestions,
        };
      });
    }
  }, [allQuestions]);

  useEffect(() => {
    if (selectedSubCategory === "") {
      setFileType("");
    }
    if (selectedSubCategory === "video") {
      setFileType("video");
    }
    if (selectedSubCategory === "supplementaryMaterial") {
      setFileType("pdf");
    }
    if (selectedSubCategory === "image") {
      setFileType("image");
    }
    if (selectedSubCategory === "audio") {
      setFileType("audio");
    }
    if (selectedCategory === "readingMaterial") {
      setFileType("pdf");
    }
  }, [selectedSubCategory, selectedCategory]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="w-100">
        <div className="d-flex justify-content-center">
          <div className="w-75">
            <Card className="mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <ArrowBackIcon
                    sx={{
                      border: "1px solid black",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                    onClick={goBack}
                  />
                  <h2 className="text-center w-50 text-center align-self-end m-auto">
                    {sectionName}
                  </h2>
                </div>
                <Form.Group className="mb-3 mt-4">
                  <Form.Label>Content Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Content Title"
                    id="courseDescription"
                    name="contentTitle"
                    value={contentDetails.contentTitle}
                    onChange={handleTitleChange}
                    className="text-dark"
                    required
                  />
                  <div className="text-danger mt-2">{errors.contentTitle}</div>
                </Form.Group>
                {errors.quiz && (
                  <div className="text-danger mt-2">{errors.quiz}</div>
                )}
              </Card.Body>
            </Card>
            <Card className="mb-3">
              <Card.Body>
                <Form.Group className="mb-3 border-bottom py-5">
                  <Form.Label>Category</Form.Label>
                  <br />
                  <FormControl>
                    <select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedCategory}
                      onChange={handleChange}
                      className="border p-2"
                      disabled={editMode}
                    >
                      {courseCategoryOptions.map((category) => (
                        <option key={Math.random()} value={category.value}>
                          {category.label}
                        </option>
                      ))}
                    </select>
                  </FormControl>
                </Form.Group>

                {selectedCategory &&
                  selectedCategory !== "readingMaterial" &&
                  selectedCategory !== "capstoneProject" ? (
                  <Form.Group className="mb-3 border-bottom py-5">
                    <Form.Label>Sub Category</Form.Label>
                    <br />
                    <FormControl>
                      <select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedSubCategory}
                        onChange={handleSubCategoryChange}
                        className="border p-2"
                        disabled={editMode}
                      >
                        <option value="">Choose Sub-category</option>
                        {subCategoryOfCourse
                          .filter((category) => {
                            if (category.value === "quizSubjective") {
                              return hasFeature(FEATURES.SUBJECTIVE_QUIZ);
                            }
                            // Commenting out manual mode as requested
                            if (category.value === "quiz") {
                              return false;
                            }
                            return true;
                          })
                          .map((category) => (
                            <option key={category.value} value={category.value}>
                              {category.label}
                            </option>
                          ))}

                      </select>
                    </FormControl>
                  </Form.Group>
                ) : null}
              </Card.Body>
            </Card>
            {selectedSubCategory === "quiz" || selectedSubCategory === "quizSubjective" ? (
              <Card className="mb-3">
                {selectedSubCategory === "quiz" ? (
                  <Quiz
                    handleQuizSubmit={handleQuizSubmit}
                    removeQuiz={removeQuiz}
                    goBack={goBack}
                    addQuizToContent={addQuizToContent}
                    passingPercentage={passingPercentage}
                    setPassingPercentage={setPassingPercentage}
                    updateQuizContent={updateQuizContent}
                    isEditMode={isEditMode}
                    activeQuiz={activeQuiz}
                    resetActiveQuiz={resetActiveQuiz}
                    updateQuizQuestion={updateQuizQuestion}
                    finalAssessment={finalAssessment}
                    setFinalAssessment={setFinalAssessment}
                    quizTimer={quizTimer}
                    setQuizTimer={setQuizTimer}
                    scheduledAttempt={scheduledAttempt}
                    setScheduledAttempt={setScheduledAttempt}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    startTime={startTime}
                    setStartTime={setStartTime}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    endTime={endTime}
                    setEndTime={setEndTime}
                    isProctored={isProctored}
                    setIsProctored={setIsProctored}
                    maxAttempts={maxAttempts}
                    setMaxAttempts={setMaxAttempts}
                    allowMultipleAttempts={allowMultipleAttempts}
                    setAllowMultipleAttempts={setAllowMultipleAttempts}
                    effectiveCourseId={effectiveCourseId}
                    activeSection={activeSection}
                  />
                ) : (
                  <SubjectiveQuiz
                    handleQuizSubmit={() => { }}
                    removeQuiz={() => { }}
                    goBack={goBack}
                    addQuizToContent={addQuizToContent}
                    updateQuizContent={updateQuizContent}
                    isEditMode={isEditMode}
                    activeQuiz={activeQuiz}
                    updateQuizQuestion={updateQuizQuestion}
                    resetActiveQuiz={resetActiveQuiz}
                    passingPercentage={passingPercentage}
                    setPassingPercentage={setPassingPercentage}
                    finalAssessment={finalAssessment}
                    setFinalAssessment={setFinalAssessment}
                    quizTimer={quizTimer}
                    setQuizTimer={setQuizTimer}
                    scheduledAttempt={scheduledAttempt}
                    setScheduledAttempt={setScheduledAttempt}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    startTime={startTime}
                    setStartTime={setStartTime}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    endTime={endTime}
                    setEndTime={setEndTime}
                    effectiveCourseId={effectiveCourseId}
                    activeSection={activeSection}
                    contentDetails={contentDetails}
                  />
                )}
              </Card>
            ) : null}

            {selectedSubCategory === "quizGeneration" && isEditMode ? (
              <Card className="mb-3">
                <Quiz
                  handleQuizSubmit={handleQuizSubmit}
                  removeQuiz={removeQuiz}
                  sectionId={sectionId}
                  goBack={goBack}
                  addQuizToContent={addQuizToContent}
                  passingPercentage={passingPercentage}
                  setPassingPercentage={setPassingPercentage}
                  updateQuizContent={updateQuizContent}
                  isEditMode={isEditMode}
                  activeQuiz={activeQuiz}
                  resetActiveQuiz={resetActiveQuiz}
                  updateQuizQuestion={updateQuizQuestion}
                  finalAssessment={finalAssessment}
                  setFinalAssessment={setFinalAssessment}
                  quizTimer={quizTimer}
                  setQuizTimer={setQuizTimer}
                  scheduledAttempt={scheduledAttempt}
                  setScheduledAttempt={setScheduledAttempt}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  startTime={startTime}
                  setStartTime={setStartTime}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  endTime={endTime}
                  setEndTime={setEndTime}
                  isProctored={isProctored}
                  setIsProctored={setIsProctored}
                  maxAttempts={maxAttempts}
                  setMaxAttempts={setMaxAttempts}
                  allowMultipleAttempts={allowMultipleAttempts}
                  setAllowMultipleAttempts={setAllowMultipleAttempts}
                  effectiveCourseId={effectiveCourseId}
                  activeSection={activeSection}
                />
              </Card>
            ) : null}

            {selectedSubCategory === "supplementaryMaterial" ||
              selectedSubCategory === "video" ||
              selectedCategory === "readingMaterial" ||
              selectedSubCategory === "image" ||
              selectedSubCategory === "audio" ? (
              <Card className={` ${fileType === "" ? "d-none" : ""}`}>
                <div className={` px-4 py-3  `}>
                  <div className="border-bottom py-2">
                    <div>
                      <h4 className="mb-0">Add Resource</h4>
                      <div>
                        {selectedSubCategory === "" ? "" : null}
                        {selectedSubCategory === "video"
                          ? "Upload your course video here. Accepted video format only mp4"
                          : null}
                        {selectedSubCategory === "supplementaryMaterial" ||
                          selectedCategory === "readingMaterial"
                          ? "Upload the supplementary material. Only pdf format is accepted"
                          : null}
                        {selectedSubCategory === "image"
                          ? "Upload your course image here. Accepted all the image format"
                          : null}
                        {selectedSubCategory === "audio"
                          ? "Upload your course audio here. Accepted all the audio format"
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
                <Card.Body>
                  {fileInfo || fileName ? (
                    <div className="text-danger">
                      {fileInfo?.name || fileName}
                    </div>
                  ) : null}
                  {fileType ? (
                    <UploadFile
                      fileType={fileType}
                      handleFileChange={handleFileChange}
                    />
                  ) : null}

                  {fileInfo && !isEditMode ? (
                    isFileUploadLoading ? (
                      <div className="d-flex justify-content-center mt-3">
                        <CircularProgress />
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center mt-3">
                        <Button onClick={handleUploadFile}>Upload</Button>
                      </div>
                    )
                  ) : null}
                  {isEditMode ? (
                    <div className="d-flex justify-content-center mt-3">
                      {isFileUploadLoading ? (
                        <CircularProgress />
                      ) : (
                        <Button onClick={handleUpdateFile}>Update</Button>
                      )}
                    </div>
                  ) : null}
                </Card.Body>
              </Card>
            ) : null}

            {selectedSubCategory === "quizBulkUpload" ? (
              <QuizBulkUpload
                handleQuizBulkUpload={handleQuizBulkUpload}
                quizGenerationResponseData={quizGenerationResponseData}
                submitQuizGenerationForm={() => { }}
                handleGeneratedQuizSubmit={handleGeneratedQuizSubmit}
                scheduledAttempt={scheduledAttempt}
                setScheduledAttempt={setScheduledAttempt}
                startDate={startDate}
                setStartDate={setStartDate}
                startTime={startTime}
                setStartTime={setStartTime}
                endDate={endDate}
                setEndDate={setEndDate}
                endTime={endTime}
                setEndTime={setEndTime}
                effectiveCourseId={effectiveCourseId}
                activeSection={activeSection}
                quizTimer={quizTimer}
                setQuizTimer={setQuizTimer}
                passingPercentage={passingPercentage}
                setPassingPercentage={setPassingPercentage}
                finalAssessment={finalAssessment}
                setFinalAssessment={setFinalAssessment}
                isProctored={isProctored}
                setIsProctored={setIsProctored}
                maxAttempts={maxAttempts}
                setMaxAttempts={setMaxAttempts}
                allowMultipleAttempts={allowMultipleAttempts}
                setAllowMultipleAttempts={setAllowMultipleAttempts}
                contentTitle={contentDetails.contentTitle}
              />
            ) : null}

            {selectedSubCategory === "quizGeneration" && !isEditMode ? (
              <QuestionGenerationContainer
                submitQuizGenerationForm={submitQuizGenerationForm}
                quizGenerationResponseData={quizGenerationResponseData}
                setQuizGenerationResponseData={setQuizGenerationResponseData}
                handleGeneratedQuizSubmit={handleGeneratedQuizSubmit}
                isGenerating={isGenerating}
                initialQuizData={activeQuiz}
                quizTimer={quizTimer}
                setQuizTimer={setQuizTimer}
                activeSection={activeSection}
                setIsGenerating={setIsGenerating}
                scheduledAttempt={scheduledAttempt}
                setScheduledAttempt={setScheduledAttempt}
                startDate={startDate}
                setStartDate={setStartDate}
                startTime={startTime}
                setStartTime={setStartTime}
                endDate={endDate}
                setEndDate={setEndDate}
                endTime={endTime}
                setEndTime={setEndTime}
                passingPercentage={passingPercentage}
                setPassingPercentage={setPassingPercentage}
                finalAssessment={finalAssessment}
                setFinalAssessment={setFinalAssessment}
                isProctored={isProctored}
                setIsProctored={setIsProctored}
                maxAttempts={maxAttempts}
                setMaxAttempts={setMaxAttempts}
                allowMultipleAttempts={allowMultipleAttempts}
                setAllowMultipleAttempts={setAllowMultipleAttempts}
                courseDomain={savedCourse?.courseDomain}
                courseDepartment={savedCourse?.courseDepartment}
                learningOutcomes={savedCourse?.learningOutcome}
              />
            ) : null}

            {selectedSubCategory === "codeSandbox" ||
              selectedCategory === "capstoneProject" ? (
              <Codesandbox
                handleSubmit={isEditMode ? updateProblemStatementToContents : addProblemStatementToContents}
                activeContent={activeContent}
                editMode={isEditMode}
                savedCourse={savedCourse}
                editSavedCourse={editSavedCourse}
                courseId={courseId}
                activeSection={activeSection}
                effectiveCourseId={effectiveCourseId}
              />
            ) : null}
          </div>
        </div>
      </div>
      <ToastMessage
        open={showToast}
        message="Updated successfully"
        closeTiming={500}
        handleClose={handleToastClose}
      />
    </LocalizationProvider>
  );
};

export default AddLecture;